import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/account'
import { ACTION_TYPES as NOTIFICATION_TYPES } from 'store/reducers/notification'
import { getAccount as getAccountService } from 'services'
import messages from 'config/messages'

const { ACCOUNT_REQUEST, ACCOUNT_SUCCESS, ACCOUNT_ERROR } = ACTION_TYPES

export function *getAccount() {
  try {
    const response = yield call(getAccountService)
    yield put({ type: ACCOUNT_SUCCESS, payload: response.data })
  } catch (err) {
    yield put({ type: ACCOUNT_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: messages.requestError.title, type: 'error' }
    })
  }
}

export default function *watchAccount() {
  yield takeLatest(ACCOUNT_REQUEST, getAccount)
}
